import {
  IUserActionHistoryItem as Data,
  IUserActionHistoryItemCollection as Collection,
} from '@/typings/api/Marks/EventLog'

import { BaseMarksApiAuth } from '@/api/BaseApiAuth'
import {
  BaseApiParams,
  BaseApiResponse,
} from '@/typings/common'
import { AxiosRequestConfig } from 'axios'

export class EventLogApi extends BaseMarksApiAuth<Data, Collection> {
  protected readonly endpoint = 'event_log';

  protected readonly hasFinishSlash = false;

  public getUserActionHistory(procedure_id: string, rawParams: BaseApiParams, config?: AxiosRequestConfig) {
    const path = 'user_action_history'
    const [url, params] = this.getUrl(path, { procedure_id, ...rawParams })
    return this.request<never, BaseApiResponse<Collection>>(
      'GET',
      url,
      { params, ...config },
    )
  }
}
